
import { EditUserDialog } from './EditUserDialog';
import { ChangeRoleDialog } from './ChangeRoleDialog';
import { DeactivateUserDialog } from './DeactivateUserDialog';
import { ResendInvitationDialog } from './ResendInvitationDialog';
import { DeleteUserDialog } from './DeleteUserDialog';
import { User } from '@/types/user';

interface UserDialogsProps {
  user: User;
  editDialogOpen: boolean;
  setEditDialogOpen: (open: boolean) => void;
  roleDialogOpen: boolean;
  setRoleDialogOpen: (open: boolean) => void;
  deactivateDialogOpen: boolean;
  setDeactivateDialogOpen: (open: boolean) => void;
  resendInvitationDialogOpen: boolean;
  setResendInvitationDialogOpen: (open: boolean) => void;
  deleteDialogOpen: boolean;
  setDeleteDialogOpen: (open: boolean) => void;
  onUserUpdated: () => void;
}

export function UserDialogs({
  user,
  editDialogOpen,
  setEditDialogOpen,
  roleDialogOpen,
  setRoleDialogOpen,
  deactivateDialogOpen,
  setDeactivateDialogOpen,
  resendInvitationDialogOpen,
  setResendInvitationDialogOpen,
  deleteDialogOpen,
  setDeleteDialogOpen,
  onUserUpdated
}: UserDialogsProps) {
  return (
    <>
      <EditUserDialog
        open={editDialogOpen}
        onOpenChange={setEditDialogOpen}
        user={user}
        onUserUpdated={onUserUpdated}
      />

      <ChangeRoleDialog
        open={roleDialogOpen}
        onOpenChange={setRoleDialogOpen}
        user={user}
        onUserUpdated={onUserUpdated}
      />

      <DeactivateUserDialog
        open={deactivateDialogOpen}
        onOpenChange={setDeactivateDialogOpen}
        user={user}
        onUserUpdated={onUserUpdated}
      />

      <ResendInvitationDialog
        open={resendInvitationDialogOpen}
        onOpenChange={setResendInvitationDialogOpen}
        user={user}
        onInvitationResent={onUserUpdated}
      />

      <DeleteUserDialog
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        user={user}
        onUserDeleted={onUserUpdated}
      />
    </>
  );
}
